import { render, staticRenderFns } from "./Congratulations.vue?vue&type=template&id=5c8dca80&scoped=true&"
import script from "./Congratulations.vue?vue&type=script&lang=js&"
export * from "./Congratulations.vue?vue&type=script&lang=js&"
import style0 from "./Congratulations.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Congratulations.vue?vue&type=style&index=1&id=5c8dca80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8dca80",
  null
  
)

export default component.exports